document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-b2b-quick-order-form]').forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var items = [];
      form.querySelectorAll('[data-b2b-quick-order-input]').forEach(function (input) {
        var quantity = Number(input.value);
        var minimum = Number(input.dataset.b2bMin);
        if (quantity > 0 && quantity < minimum) quantity = minimum;
        if (quantity > 0) items.push({ id: Number(input.dataset.variantId), quantity: quantity });
      });
      var status = form.querySelector('[data-b2b-quick-order-status]');
      if (!items.length) { status.textContent = 'Choose a quantity to add.'; return; }
      var button = form.querySelector('[data-b2b-quick-order-submit]'); button.disabled = true;
      try {
        var response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        var payload = await response.json();
        if (!response.ok) {
          var apiError = window.AdenzoB2B && window.AdenzoB2B.getCartErrorMessage
            ? window.AdenzoB2B.getCartErrorMessage(payload)
            : payload.description;
          throw new Error(apiError || 'Unable to add all selected items.');
        }
        status.textContent = 'Items added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) { status.textContent = error.message; } finally { button.disabled = false; }
    });
  });
});
